import { render, staticRenderFns } from "./AccostForm.vue?vue&type=template&id=f2b8f7b0&scoped=true"
import script from "./AccostForm.vue?vue&type=script&lang=js"
export * from "./AccostForm.vue?vue&type=script&lang=js"
import style0 from "./AccostForm.vue?vue&type=style&index=0&id=f2b8f7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b8f7b0",
  null
  
)

export default component.exports